<template>
    <div>
        <span v-if="label" class="label">{{ label }}</span>
        <v-row v-if="!chip" :dense="dense">
            <v-col :cols="cols" :md="colsMd" v-for="(item, i) in itemsMap" :key="i">
                <v-btn
                    :class="['normal-btn pa-0', {'disable-events': readonly}]"
                    class="kimsa-elevation" block
                    :height="height" :outlined="outlined"
                    :color="colorBtn(item.value)"
                    @click="clickBtn(item.value)"
                >
                    <div v-if="withIcon">
                        <v-icon :size="item.size_icon" :color="model === item.value ? 'white' : color">
                            {{ item.icon }}
                        </v-icon>
                        <br>
                        <div class="item-name">
                            {{ item[itemText] }}
                        </div>
                    </div>
                    <div v-else-if="withImages">
                        <v-img
                            :height="height/1.5"
                            :width="height/1.5"
                            eager class="mx-auto"
                            :lazy-src="imgPlaceholder"
                            :src="image(item.src)"
                        />
                        <div class="item-name">
                            {{ item[itemText] }}
                        </div>
                    </div>
                    <div v-else>
                        {{ item[itemText] }}
                    </div>
                </v-btn>

            </v-col>
        </v-row>
        <div v-else class="kimsa-pills">
            <button
                type="button"
                v-for="(item, i) in itemsMap" :key="i"
                :class="['kimsa-pill', {'kimsa-pill--active': isActive(item.value)}, {'disable-events': readonly}]"
                @click="clickBtn(item.value)"
            >
                {{ item[itemText] }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "KimsaSelect",
    props: {
        color: {
            type: String,
            default: 'secondary'
        },
        label: {
            type: String,
            default: ''
        },
        height: {
            type: Number,
            default: 0
        },
        elevation: {
            type: Number,
            default: 0
        },
        items: {
            type: Array,
            default: () => []
        },
        values: {
            type: Array,
            default: () => []
        },
        value: {
            type: [Object, String],
            default: null,
        },
        withIcon: {
            type: Boolean,
            default: false
        },
        withImages: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        chip: {
            type: Boolean,
            default: false
        },
        tile: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        cols: {
            type: [String, Number],
            default: '6'
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        bordered: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        colsMd: {
            type: [String, Number],
            default: undefined
        },
        itemText: {
            type: String,
            default: 'name'
        }
    },
    data() {
        return {
            model: '',
            array: [],
        }
    },
    mounted() {
        const vm = this
        setTimeout(function () {
            vm.setDefaults()
        }, 300)
    },
    methods: {
        colorBtn(value) {
            const vm = this
            let color = vm.outlined ? '' : 'transparent'
            if (vm.multiple) {
                return vm.array.includes(value) ? vm.color : color
            } else {
                return vm.model === value ? vm.color : color
            }
        },
        isActive(value) {
            const vm = this
            return vm.multiple ? vm.array.includes(value) : vm.model === value
        },
        clickBtn(value) {
            const vm = this
            if (vm.multiple) {
                vm.array.includes(value) ? vm.array.splice(vm.array.indexOf(value), 1) : vm.array.push(value)
            } else {
                vm.model = value
            }
        },
        image(src) {
            try {
                return require(`@/assets/${src}`);
            } catch (e) {
                return src
            }
        },
        setDefaults() {
            const vm = this
            // console.log('kimsa select defaults', vm.values)
            if (vm.values.length > 0) vm.array = vm.values
            vm.model = vm.value
        },
        reset() {
            const vm = this
            vm.array = []
            vm.model = ''
        }
    },
    computed: {
        itemsMap() {
            const vm = this
            return vm.items.map(item => {
                item.color = vm.colorBtn(item.value)
                return item
            })
        }
    },
    watch: {
        model(val) {
            const vm = this
            if (!vm.multiple) vm.$emit('change', val)
        },
        array(val) {
            const vm = this
            if (vm.multiple) vm.$emit('change', val)
        },
        values() {
            this.setDefaults()
        },
        value() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>

.label {
    display: block;
    font-size: var(--fs-label);
    font-weight: 500;
    color: var(--v-txtSecondary-base);
    margin-bottom: 6px;
}

.disable-events {
    pointer-events: none
}

.kimsa-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
}

.kimsa-pill {
    height: 38px;
    padding: 0 16px;
    border-radius: 8px;
    border: 1px solid var(--v-outline-base);
    background: var(--v-surface-base);
    color: inherit;
    font-size: 14px;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    outline: none;
    transition: border-color .15s ease, background-color .15s ease, color .15s ease;
}

.kimsa-pill--active {
    background: rgba(102, 204, 204, 0.12);
    border-color: var(--v-secondary-base);
    color: var(--v-accent-base);
    font-weight: 600;
}

.tile {
    border-radius: 0 !important;
    border: 1px solid rgba(204, 204, 204, .5) !important;
}

.bordered {
    border: 1px solid rgba(102, 204, 204, 0.5) !important;
}

.item-name {
    font-size: 11px;
    line-height: 18px;
}

</style>